import { render, staticRenderFns } from "./StyledDatePicker.vue?vue&type=template&id=473c6340&"
import script from "./StyledDatePicker.vue?vue&type=script&lang=js&"
export * from "./StyledDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports